// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.completionReportModal__D21BY {
  width: 720px;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 810px) {
  .completionReportModal__D21BY {
    width: 100%;
    height: 98%;
  }
}

.modalBody__qW303 {
  flex: 1;
  overflow-y: auto;
  padding: 25px 25px 0px 25px;
}
.modalBody__qW303::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.modalBody__qW303::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.modalBody__qW303::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modalBody__qW303::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.modalFooter__s7UAM {
  padding: 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

.gifCenter__rwCwe {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CompletionReportModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,WAAA;IACA,WAAA;EAxEF;AACF;;AA2EA;EACE,OAAA;EACA,gBAAA;EACA,2BAAA;AAxEF;AAQE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AANJ;AASE;EACE,+BAAA;EACA,kBAAA;AAPJ;AAUE;EACE,8BAAA;EACA,kBAAA;AARJ;AAWE;EACE,gBAAA;EACA,kBAAA;AATJ;;AA4DA;EACE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAzDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.completionReportModal {\n  width: 720px;\n  height: 700px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 810px) {\n    width: 100%;\n    height: 98%;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  overflow-y: auto;\n  padding: 25px 25px 0px 25px;\n\n  @include scrollBar;\n}\n\n.modalFooter {\n  padding: 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n\n.gifCenter {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"completionReportModal": `completionReportModal__D21BY`,
	"modalBody": `modalBody__qW303`,
	"modalFooter": `modalFooter__s7UAM`,
	"gifCenter": `gifCenter__rwCwe`
};
module.exports = ___CSS_LOADER_EXPORT___;
